import React, {Fragment} from "react";
import StepButton from "components/Step/StepButton";
import StepQuestion from "components/Step/StepQuestion";
import {Input} from "reactstrap";
import StepDatePicker from "components/Step/StepDatePicker";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import IdTypeEnum, {getDocumentNameByIdType} from "domain/Customer/IdTypeEnum";
import StepFeedback from "components/Step/StepFeedback";
import * as ValidationRule from "utils/ValidationRule";
import ValidationMethod from "utils/ValidationMethods";
import GenderEnum from "domain/Registerv2/GenderEnum";
import StepInputLabel from "components/Step/StepInputLabel";
import StepInformation from "components/Step/StepInformation";

export default class DocumentDetailCaptureStep extends React.Component {


    constructor(props, context) {
        super(props, context);

        this.numberText = "ID Number";
        this.numberVerb = this.props[RegistrationElements.ID_NUMBER] && this.props[RegistrationElements.ID_NUMBER].length > 0 ? "confirm" : "input";
        this.expiryVerb = this.props[RegistrationElements.ID_EXPIRY] && this.props[RegistrationElements.ID_EXPIRY].length > 0 ? "confirm" : "input";

        this.exampleIdNumber = "eg. 9012254800085";
        this.exampleExpiryDate = "eg. " + (new Date().getFullYear() + 3) + "-04-28"

        let idType = this.props[RegistrationElements.ID_TYPE];

        let validations;
        if (idType === IdTypeEnum.SA_ID) {
            validations = [{
                field: RegistrationElements.ID_NUMBER,
                yupRule: ValidationRule.getSAIDNumberValidatorBeforeDobGender(this.numberText, true),
                value: this.props[RegistrationElements.ID_NUMBER]
            }];
        } else {

            if (idType === IdTypeEnum.ASYLUM_PAPER) {
                this.numberText = "Asylum Document Number";
                this.exampleIdNumber = "eg. PUCHN9310140M";
            } else if (idType === IdTypeEnum.FOREIGN_PASSPORT) {
                this.numberText = "Passport Number";
                this.exampleIdNumber = "eg. 31195855";
            }
            else if (idType === IdTypeEnum.FOREIGN_ID) {
                this.numberText = "ID Number";
                this.exampleIdNumber = "eg. 31195855";
            }

            validations = [{
                field: RegistrationElements.ID_NUMBER,
                yupRule: ValidationRule.getAlphaNumericValidator(this.numberText, true),
                value: this.props[RegistrationElements.ID_NUMBER]
            }, {
                field: RegistrationElements.ID_EXPIRY,
                yupRule: ValidationRule.getIdExpiryDateValidator("Expiry date", true),
                value: this.props[RegistrationElements.ID_EXPIRY]
            }];
        }

        let errors = ValidationMethod.validateInitial(this, validations);
        this.state = {
            errors: errors
        };
    }

    btnNextClick(idNumber) {

        let data = {};
        if (this.props[RegistrationElements.ID_TYPE] === IdTypeEnum.SA_ID) {

            let year = 1900 + parseInt(idNumber.substring(0, 2), 10);
            let currentYear = new Date().getFullYear();
            if (currentYear - year > 100)
                year += 100;
            let month = idNumber.substring(2, 4);
            let day = idNumber.substring(4, 6);

            let genderCode = parseInt(idNumber.substring(6, 10), 10);
            let gender = genderCode > 4999 ? GenderEnum.MALE : GenderEnum.FEMALE;

            data[RegistrationElements.DOB] = year + '-' + month + '-' + day;
            data[RegistrationElements.GENDER] = gender;
        }


        if (this.props.onNextClick) this.props.onNextClick(data);
    }

    onChange(e) {
        this.fireChangeEvent(e.target.id, e.target.value);
    }

    fireChangeEvent(key, value) {
        ValidationMethod.validateOnChange(this, key, value);

        if (this.props.onKeyValueChange)
            this.props.onKeyValueChange(key, value);
    }

    isInvalid(key) {
        return this.state.errors[key] !== undefined && this.state.errors[key].length > 0
    }

    render() {

        let idType = this.props[RegistrationElements.ID_TYPE];
        let idNumber = this.props[RegistrationElements.ID_NUMBER];
        let idExpiry = this.props[RegistrationElements.ID_EXPIRY];

        return <Fragment>
            <StepQuestion>
                Please {this.numberVerb} your {this.numberText}:
            </StepQuestion>
            <StepInputLabel>
                {this.numberText}
                <StepInformation>
                    The number must match the document that you uploaded.
                </StepInformation>
            </StepInputLabel>
            <Input
                id={RegistrationElements.ID_NUMBER}
                type={"text"}
                placeholder={this.exampleIdNumber}
                value={idNumber}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid(RegistrationElements.ID_NUMBER)}
            />
            <StepFeedback>
                {this.state.errors[RegistrationElements.ID_NUMBER]}
            </StepFeedback>
            {
                idType !== IdTypeEnum.SA_ID && <Fragment>
                    <StepQuestion>
                        Please {this.expiryVerb} the expiry date on your {getDocumentNameByIdType(idType)}:
                    </StepQuestion>
                    <StepInputLabel>
                        Expiry Date
                        <StepInformation>
                            The expiry date must match the document that you uploaded.
                        </StepInformation>
                    </StepInputLabel>
                    <StepDatePicker
                        id={RegistrationElements.ID_EXPIRY}
                        type={"ID_EXPIRY"}
                        placeholder={this.exampleExpiryDate}
                        value={idExpiry}
                        onChange={(dt) => {
                            this.fireChangeEvent(RegistrationElements.ID_EXPIRY, dt);
                        }}
                        invalid={this.isInvalid(RegistrationElements.ID_EXPIRY)}
                    />
                    <StepFeedback>
                        {this.state.errors[RegistrationElements.ID_EXPIRY]}
                    </StepFeedback>
                </Fragment>
            }

            <StepButton
                color={"primary"}
                onClick={() => this.btnNextClick(idNumber)}
                disabled={Object.keys(this.state.errors).length > 0}
            >
                {"Next"}
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {"Back"}
            </StepButton>
        </Fragment>
    }
}